import React, { useCallback, useEffect, useState } from 'react';
import { AlertOctagon } from 'lucide-react';
import SectionShell from './SectionShell';
import { jobBriefApi } from '../../../services/jobBriefApi';

/**
 * ErrorTrapsSection — select from the canonical error-trap catalog.
 * Selections drive `HPToolsSection`, which asks the backend for the
 * matching recommended tools whenever this list changes.
 */
export default function ErrorTrapsSection({ draft, onChange }) {
  const traps = draft.error_traps || [];
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    jobBriefApi.getErrorTrapCatalog().then((d) => setCatalog(d?.error_traps || []));
  }, []);

  const toggle = useCallback((key) => {
    const next = traps.includes(key) ? traps.filter((t) => t !== key) : [...traps, key];
    onChange({ error_traps: next });
  }, [traps, onChange]);

  return (
    <SectionShell
      icon={AlertOctagon}
      title="Error Traps"
      subtitle="Pick every trap that could bite this crew today. HP Tool recommendations update automatically."
      color="#fb923c"
      badge={traps.length ? `${traps.length} selected` : 'Pick any that apply'}
      testId="jbv2-section-error-traps"
    >
      {catalog.length === 0 && (
        <div className="jbv2-empty">Loading catalog…</div>
      )}
      <div className="jbv2-chips" data-testid="jbv2-error-traps-chips">
        {catalog.map((c) => {
          const on = traps.includes(c.key);
          return (
            <button
              key={c.key}
              type="button"
              className={`jbv2-chip${on ? ' jbv2-chip--on' : ''}`}
              onClick={() => toggle(c.key)}
              data-testid={`jbv2-error-trap-${c.key}`}
              aria-pressed={on}
            >
              {c.label}
            </button>
          );
        })}
      </div>
    </SectionShell>
  );
}
